import { mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('modal', ['modal']),
    modalData () {
      return this.modal.data
    }
  },
  methods: {
    ...mapActions('modal', ['showModal', 'closeModal']),
    openModal (name, data = {}, options = {}) {
      this.showModal({
        size: '630px',
        ...options,
        name,
        data
      })
    }
  }
}
